import React from 'react';
import { useTranslation } from 'react-i18next';

function PlaybackControls({
  isPlaying, onTogglePlay, onStop,
  tempo, onTempoChange,
  isLooping, onToggleLoop,
  saxType, onSaxTypeChange,
  currentNoteIndex, totalNotes
}) {
  const { t } = useTranslation();
  return (
    <div className="saxtutor-controls" role="toolbar" aria-label={t('saxTutor.playbackControls', 'Playback controls')}>
      <div className="saxtutor-controls-row">
        <div className="saxtutor-transport">
          <button
            className={`saxtutor-btn ${isPlaying ? 'playing' : ''}`}
            onClick={onTogglePlay}
            title={isPlaying ? t('saxTutor.pause') : t('saxTutor.play')}
            aria-label={isPlaying ? t('saxTutor.pause') : t('saxTutor.play')}
          >
            {isPlaying ? '⏸' : '▶'}
          </button>
          <button className="saxtutor-btn" onClick={onStop} title={t('saxTutor.stop')} aria-label={t('saxTutor.stop')}>
            ⏹
          </button>
          <button
            className={`saxtutor-btn ${isLooping ? 'active' : ''}`}
            onClick={onToggleLoop}
            title={t('saxTutor.loop')}
            aria-label={t('saxTutor.loop')}
            aria-pressed={isLooping}
          >
            🔁
          </button>
        </div>

        <div className="saxtutor-tempo">
          <label>
            {t('saxTutor.tempo')}: <strong>{tempo}</strong> BPM
          </label>
          <input
            type="range"
            min="30"
            max="240"
            value={tempo}
            onChange={(e) => onTempoChange(Number(e.target.value))}
            className="saxtutor-tempo-slider"
          />
        </div>

        <div className="saxtutor-sax-select">
          <label>
            {t('saxTutor.sax')}:
            <select value={saxType} onChange={(e) => onSaxTypeChange(e.target.value)}>
              <option value="Soprano">{t('saxTutor.soprano')}</option>
              <option value="Alto">{t('saxTutor.alto')}</option>
              <option value="Tenor">{t('saxTutor.tenor')}</option>
              <option value="Baritone">{t('saxTutor.baritone')}</option>
            </select>
          </label>
        </div>

        <div className="saxtutor-position">
          {currentNoteIndex >= 0
            ? t('saxTutor.notePosition', { current: currentNoteIndex + 1, total: totalNotes })
            : t('saxTutor.noteCount', { count: totalNotes })
          }
        </div>
      </div>
    </div>
  );
}

export default PlaybackControls;
